import { Navigate } from 'react-router-dom'
import { useAuth } from '@/hooks/useAuth'

interface IProps { }

const HomeRoute = ({ }: IProps) => {
    const { isLoggedIn } = useAuth()
    return isLoggedIn ? <Navigate to={'/dashboard'} /> : <Navigate to={'/home'} />
}

export default HomeRoute